// Import model
import { StartLeadAppointmentSendCustomAppointmentConfirmationEmailRequest } from '../models/StartLeadAppointmentSendCustomAppointmentConfirmationEmailRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartLeadAppointmentSendCustomAppointmentConfirmationEmailRequest - handles JSON serialization and deserialization with type validation
 */
export class StartLeadAppointmentSendCustomAppointmentConfirmationEmailRequestSerializer {
  /**
   * Deserializes a JSON string into a StartLeadAppointmentSendCustomAppointmentConfirmationEmailRequest instance
   */
  static deserialize(json: string): StartLeadAppointmentSendCustomAppointmentConfirmationEmailRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartLeadAppointmentSendCustomAppointmentConfirmationEmailRequest instance
   */
  static fromObject(obj: any): StartLeadAppointmentSendCustomAppointmentConfirmationEmailRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartLeadAppointmentSendCustomAppointmentConfirmationEmailRequest');
    }


    const instance: StartLeadAppointmentSendCustomAppointmentConfirmationEmailRequest = {
      unlayerTemplateId: obj['UnlayerTemplateId'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartLeadAppointmentSendCustomAppointmentConfirmationEmailRequest instances
   */
  static deserializeArray(json: string): StartLeadAppointmentSendCustomAppointmentConfirmationEmailRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartLeadAppointmentSendCustomAppointmentConfirmationEmailRequest instance to a JSON string
   */
  static serialize(instance: StartLeadAppointmentSendCustomAppointmentConfirmationEmailRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartLeadAppointmentSendCustomAppointmentConfirmationEmailRequest instance to a plain object
   */
  static toObject(instance: StartLeadAppointmentSendCustomAppointmentConfirmationEmailRequest): any {
    return {
      'UnlayerTemplateId': instance.unlayerTemplateId,
    };
  }

  /**
   * Serializes an array of StartLeadAppointmentSendCustomAppointmentConfirmationEmailRequest instances to a JSON string
   */
  static serializeArray(instances: StartLeadAppointmentSendCustomAppointmentConfirmationEmailRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
